import { render } from "./RadioTiles.vue?vue&type=template&id=d3d800f8"
import script from "./RadioTiles.vue?vue&type=script&lang=js"
export * from "./RadioTiles.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__